// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"advice_wrapper__qQjzI","container":"advice_container__GMjYz","button":"advice_button__AmGnX"};